import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    step: "Step 01",
    title: "Understand",
    body: "Brief, audience, language, format, creative objective and delivery requirements.",
  },
  {
    step: "Step 02",
    title: "Develop",
    body: "Concept, script, production approach, schedule and practical budget framework.",
  },
  {
    step: "Step 03",
    title: "Execute",
    body: "Manage line production, locations, permissions, crew, vendors, equipment, logistics and on-ground workflows across India.",
  },
  {
    step: "Step 04",
    title: "Deliver",
    body: "Keep communication, production tracking and final delivery aligned with the brief.",
  },
];

export default function GoshtaHowWeWork() {
  return (
    <section
      data-testid="goshta-how-we-work"
      className="relative border-y border-white/10 bg-[#0a0a0a] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">How We Work</p>
          <h2 className="mt-5 max-w-3xl font-display text-3xl font-medium leading-tight text-neutral-100 sm:text-4xl lg:text-5xl">
            Clear thinking before the <em className="italic text-[#D4AF37]">camera rolls.</em>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-neutral-400">
            Creative ambition works best when the plan, people, budget and delivery are aligned
            from the start.
          </p>
        </Reveal>

        <div className="mt-16 space-y-px border border-white/10 bg-white/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.step} delay={i * 0.06}>
              <div className="grid grid-cols-1 gap-4 bg-[#050505] p-7 transition-colors duration-500 hover:bg-[#0f0d09] sm:grid-cols-[140px_220px_1fr] sm:items-baseline md:p-9">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">{s.step}</p>
                <h3 className="font-display text-2xl text-neutral-100">{s.title}</h3>
                <p className="text-sm leading-relaxed text-neutral-400">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
